import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

class Scores extends Component {

	render() {

		const { order, teams, year, standings } = this.props

		if (!order || !teams || !year) {
			return null
		}

		if (!standings || !standings.length) {
			return (
				<div id="scores">
					<div className="main-score-upper">{year} SCORE</div>
					<div className="main-score-lower">
						<span title="To Be Determined">
							TBD
						</span>
					</div>
					<p>
						A live score will be displayed for this ladder once the season begins.
					</p>
					<p>
						Bookmark this page with the Permanent Link below and return
						later to check your score!
					</p>
				</div>
			)
		}

		const finalsN = year >= 2026 ? 10 : 8
		const scores = computeScores(order, teams, year)

		return (
			<div id="scores">
				<div className="main-score-upper">{year} SCORE</div>
				<div className="main-score-lower">
					{Number(scores.score).toFixed(1)}
				</div>
				<div className={"grade gradecat-" + scores.grade.substr(0, 1).toLowerCase()}>{scores.grade}</div>
				<p
					data-tip="There are 6.4 quantillion different ways to rank 18 teams. This is the percentage of them that are less accurate than your ladder."
				>
					Better than {scores.betterThanRandomStr}% of all possible ladder combinations.
				</p>
				<ScoreItem
					upper="Exactly Right"
					lower={scores.exactlyRight}
					info="The number of teams occupying the correct rung."
				/>
				<ScoreItem
					upper="Off By One"
					lower={scores.offByOne}
					info="The number of teams whose position is out by one."
				/>
				<ScoreItem
					upper="Minor Premier"
					lower={isCorrectStr(scores.minorPremier)}
					info="Whether the first-placed team is correct."
				/>
				<ScoreItem
					upper="Wooden Spoon"
					lower={isCorrectStr(scores.spoon)}
					info="Whether the last-placed team is correct."
				/>
				<ScoreItem
					upper={"Top " + finalsN}
					lower={scores.topFinalists + " out of " + finalsN}
					info={"How many Top " + finalsN + " teams are correct."}
				/>
				<ScoreItem
					upper="Top 4"
					lower={scores.top4 + " out of 4"}
					info="How many Top 4 teams are correct."
				/>
				<ScoreItem
					upper="AE"
					lower={scores.mae}
					info="Absolute Error (AE) is the total number of rungs your ladder is out by. Best is 0, worst is 162."
				/>
				<ScoreItem
					upper="MSE"
					lower={Number(scores.mse).toFixed(2)}
					info="Mean Squared Error (MSE) is similar to AE, but it's more forgiving of small mistakes while punishing large ones. In technical terms, it is the average of the squared error for each team. Best is 0, worst is 108."
				/>
				<ScoreItem
					upper="RPS"
					lower={Number(scores.rps).toFixed(2)}
					info="Rank Probability Score (RPS) is more suited to forecasts that offer a range of probabilities for each team's finishing position, but it's displayed here so you can compare to such scores. It assumes that you assigned a 100% probability to each team placing. Best is 0, worst is 0.5."
				/>

				<ReactTooltip
					clickable={true}
					multiline={true}
				/>
			</div>
		)
	}
}

Scores.propTypes = {
	teams: PropTypes.object,
	order: PropTypes.array,
}

class ScoreItem extends Component {

	render()
	{
		const { upper, lower, info } = this.props

		return (
			<div className="scoreItem" data-tip={info}>
				<div className="score-upper">{upper}</div><div className="score-lower">{lower}</div>
			</div>
		)
	}
}

export function computeScores(order, teams, year) {
	const finalsN = year >= 2026 ? 10 : 8
	const scores = {
		mae: computeMAE(order, teams),
		mse: computeMSE(order, teams),
		rps: computeRPS(order, teams),
		exactlyRight: computeExactlyRight(order, teams),
		offByOne: computeOffByOne(order, teams),
		top4: computeTopN(4, order, teams),
		topFinalists: computeTopN(finalsN, order, teams),
		minorPremier: isCorrect(1, order, teams),
		spoon: isCorrect(18, order, teams),
	}

	scores.rawScore = -scores.mae + -scores.mse + scores.exactlyRight + 2 * (scores.top4 + scores.topFinalists + scores.minorPremier + scores.spoon)

	const minScore = -269.6667
	const maxScore = year >= 2026 ? 50 : 46
	scores.score = Math.abs(100 * (scores.rawScore - minScore) / (maxScore - minScore))

	scores.grade = computeGrade(scores.score)

	scores.betterThanRandom = betterThanRandom(scores.score)
	scores.betterThanRandomStr = scores.betterThanRandom
	if (scores.betterThanRandom === 100) {
		scores.betterThanRandomStr = 'almost 100'
	}

	return scores
}

export function computeMAE(order, teams)
{
	let mae = 0.0

	order.forEach((teamId, idx) => {
		const rank = idx + 1
		mae += computeMAEForTeam(teams[teamId].rank, rank)
	})

	return mae
}

function computeMAEForTeam(rank1, rank2)
{
	return Math.abs(rank1 - rank2)
}

export function computeMSE(order, teams)
{
	let mse = 0.0

	order.forEach((teamId, idx) => {
		const rank = idx + 1
		mse += Math.pow(computeMAEForTeam(teams[teamId].rank, rank), 2)
	})

	return mse / order.length
}

function computeRPS(order, teams)
{
	let rps = 0.0

	order.forEach((teamId, idx) => {
		const swarms = new Array(18).fill(0)
		swarms[idx] = 1
		rps += computeRPSForTeam(teams[teamId].rank, swarms)
	})

	return rps / Object.keys(teams).length
}

function computeRPSForTeam(actual_rank, swarms)
{
	let sum = 0.0
	let CDF_fck = 0.0
	let CDF_obsk = 0.0

	swarms.forEach((fc, idx) => {
		const obs = (actual_rank === idx + 1 ? 1 : 0)

		CDF_obsk += obs
		CDF_fck += fc

		const sqrd = Math.pow(CDF_fck - CDF_obsk, 2)

		sum += sqrd
	})

	const rps = sum / swarms.length

	return rps
}

function computeGrade(score) {
	if (score >= 100) {
		return 'Perfect'
	}
	const letterIndex = Math.floor((100 - score) / 10)

	const letters = [ 'A', 'A', 'B', 'C', 'D' ]

	let grade

	if (letterIndex >= letters.length) {
		grade = 'F'
	} else {
		grade = letters[letterIndex]
		const remainder = score % 10

		if (!letterIndex) {
			//
			// Score of 90 or higher
			//

			grade += '+'

			for (let i = 0; i <= remainder; i+=2) {
				grade += '+'
			}
		} else {
			const remainder = score % 10

			if (remainder <= 2.5) {
				grade += '-'
			} else if (remainder >= 7.5) {
				grade += '+'
			}
		}
	}

	return grade
}

function betterThanRandom(score) {
	const simFreq = [
		0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.1,0.1,0.2,0.3,0.4,0.5,0.8,1.1,1.4,1.9,2.5,3.3,4.2,5.2,6.5,7.9,9.6,11.5,13.6,15.9,18.3,21.0,24.1,27.2,30.6,33.9,37.4,41.2,45.0,48.8,52.5,56.2,59.9,63.5,67.1,70.4,73.7,76.7,79.4,82.1,84.4,86.6,88.6,90.3,91.9,93.2,94.4,95.4,96.2,97.0,97.6,98.1,98.5,98.9,99.16,99.39,99.54,99.69,99.78,99.85,99.89,99.93,99.95,99.97,99.98,99.99,99.99,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00,100.00
	]

	return simFreq[Math.floor(score)]
}

function computeExactlyRight(order, teams) {
	let count = 0
	order.forEach((teamId, idx) => {
		if (teams[teamId].rank === idx + 1) {
			count += 1
		}
	})
	return count
}

function computeOffByOne(order, teams) {
	let count = 0
	order.forEach((teamId, idx) => {
		if (Math.abs(teams[teamId].rank - idx - 1) === 1) {
			count += 1
		}
	})
	return count
}

function computeTopN(n, order, teams) {
	let count = 0
	order.slice(0, n).forEach(teamId => {
		if (teams[teamId].rank <= n) {
			count += 1
		}
	})
	return count
}

function isCorrect(n, order, teams) {
	const teamId = order[n - 1]
	if (teams[teamId].rank === n) {
		return true
	}
	return false
}

function isCorrectStr(isCorrect) {
	if (isCorrect) {
		return (
			<span className={"tip-correctness tip-correct-yes"}>
				✓
			</span>
		)
	}
	return (
		<span className={"tip-correctness tip-correct-no"}>
			✗
		</span>
	)
}



export default Scores
